<div class="root-container">
  <h3>Short Code Response Messages</h3>
  <p>When a Relay managed short code receives the keywords "stop" or "help" from an <i>onboarded phone number</i>, it responds with the <i>Client</i> configured "stop" or "help" response.</p>
  <p>When a Relay managed short code receives the keywords "stop" or "help" from an <i>unknown phone number</i>, it responds with the <i>Short Code</i> configured "stop" or "help" response.</p>
  <p>Enter a Short Code to review/edit existing response language or to add new response language.</p>
  <div class="controls-container">
    <div class="shortcode-search-container">
      <label>Short Code:</label>
      <input [formControl]="shortcodeSearchControl" name="shortCodeSearchControl" type="text">
      <button (click)="onSearchClick()" [disabled]="isSearchButtonDisabled()">Search</button>
    </div>
    @if (isShortCodeResponseDisplayVisible()) {
      <div class="response-container">
        <ng-container>
          @for (formGroup of this.shortcodeResponsesArray.controls; track formGroup) {
            <div>
              <rn-keyword-response-component [keywordGroup]="formGroup"></rn-keyword-response-component>
            </div>
          }
        </ng-container>
      </div>
    }
    <div class="button-container">
      @if (isSaveButtonVisible()) {
        <button (click)="onSaveClick()"
          [disabled]="isSaveButtonDisabled()">Save
        </button>
      }
      <button (click)="onResetClick()">Reset</button>
    </div>
  </div>
</div>
<message-dialog #saveConfirmationDialog>
</message-dialog>
